module.exports = __webpack_public_path__ + "static/media/dashboard-background-simple.312368d1.jpeg";